import React from 'react';
import Svg from 'rp-react-svg-icon';
import ResultLink from './ResultLink';

const ReplayLink = props => (
    <ResultLink
        {...props}
        urlHash="fullReplay-profiles"
        className="hp-formTable__videoIcon"
    >
        <Svg
            iconName="videoHollow"
            className="ui-icon tableShowIcon"
            size="Medium"
        />
    </ResultLink>
);

export default ReplayLink;



// WEBPACK FOOTER //
// ./src/js/shared/links/ReplayLink.jsx